module.exports = __webpack_public_path__ + "static/media/pin_banco.7a6e4495.png";